import React from 'react';
import PhoneInput from 'antd-phone-input';

/**
 * Phone entry stored as `{ dialCode, nationalNumber }`, the shape the Portal
 * writes and reads.
 */
const toStored = (next) => {
  if (!next) return undefined;

  const dialCode = next.countryCode ? `+${String(next.countryCode).replace(/\D/g, '')}` : '';
  const nationalNumber = `${next.areaCode ?? ''}${next.phoneNumber ?? ''}`.replace(/\D/g, '');

  if (!nationalNumber) return undefined;
  return { dialCode, nationalNumber };
};

const toComponent = (value) => {
  if (!value?.nationalNumber) return undefined;

  return {
    countryCode: Number(String(value.dialCode ?? '').replace(/\D/g, '')) || undefined,
    phoneNumber: String(value.nationalNumber),
  };
};

const PhoneNumberField = ({ value, onChange, disabled = false }) => (
  <PhoneInput
    enableSearch
    disabled={disabled}
    value={toComponent(value)}
    onChange={(next) => onChange?.(toStored(next))}
  />
);

export default PhoneNumberField;
